import { UserIcon } from "lucide-react";

export function NoMentorship() {
  return (
    <div className="flex flex-1 items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="mb-4 flex justify-center">
          <UserIcon className="h-12 w-12 text-gray-400" />
        </div>
        <h3 className="mb-2 text-lg font-semibold text-gray-900">
          No Mentorship Found
        </h3>
        <p className="mb-6 text-sm leading-relaxed text-gray-500">
          No mentorship found for this channel. Please refresh the page, and if
          the issue persists, please contact support.
        </p>
      </div>
    </div>
  );
}
